(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = initAdmin

var createController = require('./controllers/controller')

function initAdmin () {
  return { menuBar: init }
}

function init (serviceLocator, done) {
  createController(serviceLocator)
  done()
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/menu-bar/init.js","/components/admin/menu-bar")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vbWVudS1iYXIvaW5pdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIm1vZHVsZS5leHBvcnRzID0gaW5pdEFkbWluXG5cbnZhciBjcmVhdGVDb250cm9sbGVyID0gcmVxdWlyZSgnLi9jb250cm9sbGVycy9jb250cm9sbGVyJylcblxuZnVuY3Rpb24gaW5pdEFkbWluICgpIHtcbiAgcmV0dXJuIHsgbWVudUJhcjogaW5pdCB9XG59XG5cbmZ1bmN0aW9uIGluaXQgKHNlcnZpY2VMb2NhdG9yLCBkb25lKSB7XG4gIGNyZWF0ZUNvbnRyb2xsZXIoc2VydmljZUxvY2F0b3IpXG4gIGRvbmUoKVxufVxuIl19